import { gql } from '@apollo/client'

// Minimal query for page-wrapper breadcrumbs. Resolves from the Apollo cache
// once COMPANY_DETAIL_QUERY has loaded the same Company (normalized by id).
export const COMPANY_NAME_QUERY = gql`
  query CompanyName($id: ID!) {
    company(id: $id) {
      id
      name
    }
  }
`

// Single-company detail for the CRM Company Detail page. `company(id)` accepts
// either the DB id or the FriendlyId `number`. contacts / projects / recentOrders
// are Relay connections (read `.nodes`); contacts carry their CLV performance
// (for segment tags); performance is a live rollup computed on the backend.
export const COMPANY_DETAIL_QUERY = gql`
  query CompanyDetail($id: ID!) {
    company(id: $id) {
      id
      number
      name
      email
      phoneNumber
      lineId
      taxId
      companyType
      addressDetail
      postalCode
      createdAt {
        raw
      }
      province {
        id
        name
      }
      district {
        id
        name
      }
      salesStaff {
        id
        fullName
      }
      performance {
        id
        lifetimeRevenueSatangs
        predictedClvSatangs
        outstandingSatangs
        openQuotationsCount
        openQuotationsValueSatangs
        ordersCount
        contactsCount
        lastOrderAt {
          raw
        }
        daysSinceLastOrder
      }
      contacts(first: 50) {
        nodes {
          id
          customerNo
          fullName
          phoneNumber
          email
          lineId
          lineUrl
          performance {
            id
            clvSegment
          }
        }
      }
      recentOrders(first: 50) {
        nodes {
          id
          number
          state
          stateLabel
          selfPickup
          scmFirstName
          createdAt {
            shortDate
          }
          grandTotal {
            value
          }
          cses {
            id
            firstName
          }
          sales {
            id
            firstName
          }
          logistics {
            id
            firstName
          }
          orderShippingAddress {
            id
            postalCode
            district {
              id
              name
            }
            province {
              id
              name
            }
          }
          companyProject {
            id
            name
          }
          customer {
            id
            customerNo
            fullName
          }
        }
      }
      projects(first: 50) {
        nodes {
          id
          name
          status
          paidPrice {
            value
          }
          unpaidPrice {
            value
          }
        }
      }
      recentActivities(limit: 6) {
        id
        text
        kind
        occurredAt {
          raw
        }
      }
    }
  }
`
